import { userTypes } from './userTypes'

const init = {
    isLogin: false,
    user: {},
    allUsers: [],
    allUsersForPrint: [],
    allBuyers: [],
    meta: {},
    loading: false,
    crudLoading: false,
}

const user = (state = init, action) => {
    switch (action.type) {
        case userTypes.SIGN_IN_START:
            return {
                ...state,
            }
        case userTypes.SIGN_IN_SUCCESS:
            return {
                ...state,
            }
        case userTypes.SIGN_IN_END:
            return {
                ...state,
            }
        case userTypes.SIGN_IN_FAILED:
            return {
                ...state,
            }

        case userTypes.VERIFY_NUMBER_START:
            return {
                ...state,
                step2Loading: true,
            }
        case userTypes.VERIFY_NUMBER_SUCCESS:
            localStorage.setItem('token', action.payload.access_token)
            const firstLogin = localStorage.getItem('first_login')
            if (!firstLogin) {
                localStorage.setItem(
                    'first_login',
                    JSON.stringify({
                        announcement: true,
                        support: true,
                    })
                )
            }

            return {
                ...state,
                user: action.payload?.user,
            }
        case userTypes.VERIFY_NUMBER_FALIED:
            return {
                ...state,
                step2Loading: false,
            }
        case userTypes.VERIFY_NUMBER_END:
            return {
                ...state,
                step2Loading: false,
            }

        case userTypes.LOGOUT_USER:
            localStorage.removeItem('token')
            localStorage.removeItem('first_login')
            // window.location.href = '/auth/login'
            return init

        // -------------------- all users
        case userTypes.GET_ALL_USERS_START:
            return {
                ...state,
                loading: true,
            }
        case userTypes.GET_ALL_USERS_SUCCESS:
            return {
                ...state,
                allUsers: action.payload,
                allUsersForPrint: action.printableUsers,
                meta: action.meta,
            }
        case userTypes.GET_ALL_USERS_FAILED:
            return {
                ...state,
                loading: false,
            }
        case userTypes.GET_ALL_USERS_END:
            return {
                ...state,
                loading: false,
            }

        case userTypes.GET_ALL_BUYERS_START:
            return {
                ...state,
                allBuyers: [],
                loading: true,
            }
        case userTypes.GET_ALL_BUYERS_SUCCESS:
            return {
                ...state,
                allBuyers: action.payload,
                meta: action.meta,
            }
        case userTypes.GET_ALL_BUYERS_FAILED:
            return {
                ...state,
                loading: false,
            }
        case userTypes.GET_ALL_BUYERS_END:
            return {
                ...state,
                loading: false,
            }

        // ----------------- edit user
        case userTypes.UPDATE_A_USERS_START:
            return {
                ...state,
                crudLoading: true,
            }
        case userTypes.UPDATE_A_USERS_SUCCESS:
            return {
                ...state,
                allUsers: action.payload,
            }
        case userTypes.UPDATE_A_USERS_FAILED:
            return {
                ...state,
                crudLoading: false,
                allUsers: action.payload,
            }
        case userTypes.UPDATE_A_USERS_END:
            return {
                ...state,
                crudLoading: false,
            }

        // -------------------- add user
        case userTypes.ADD_A_USERS_START:
            return {
                ...state,
                loading: true,
                crudLoading: true,
            }
        case userTypes.ADD_A_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                allUsers: action.payload,
            }
        case userTypes.ADD_A_USERS_FAILED:
            return {
                ...state,
                crudLoading: false,
                allUsers: action.payload,
            }
        case userTypes.ADD_A_USERS_END:
            return {
                ...state,
                crudLoading: false,
            }

        // --------- delete user
        case userTypes.DELETE_A_USERS_START:
            return {
                ...state,
                crudLoading: true,
            }
        case userTypes.DELETE_A_USERS_SUCCESS:
            return {
                ...state,
                allUsers: action.payload,
            }
        case userTypes.DELETE_A_USERS_FAILED:
            return {
                ...state,
                crudLoading: false,
                allUsers: action.payload,
            }
        case userTypes.DELETE_A_USERS_END:
            return {
                ...state,
                crudLoading: false,
            }

        // ----------------- edit user profile
        case userTypes.UPDATE_A_USER_PROFILE_START:
            return {
                ...state,
                crudLoading: true,
            }
        case userTypes.UPDATE_A_USER_PROFILE_SUCCESS:
            return {
                ...state,
                user: action.payload,
            }
        case userTypes.UPDATE_A_USER_PROFILE_FAILED:
            return {
                ...state,
                crudLoading: false,
            }
        case userTypes.UPDATE_A_USER_PROFILE_END:
            return {
                ...state,
                crudLoading: false,
            }

        //------------------ get a user by token
        case userTypes.GET_A_USER_BY_TOKEN_START:
            return {
                ...state,
                crudLoading: true,
            }
        case userTypes.GET_A_USER_BY_TOKEN_SUCCESS:
            return {
                ...state,
                user: action.payload,
            }
        case userTypes.GET_A_USER_BY_TOKEN_FAILED:
            return {
                ...state,
                crudLoading: false,
            }
        case userTypes.GET_A_USER_BY_TOKEN_END:
            return {
                ...state,
                crudLoading: false,
            }
        case userTypes.DECREASE_UN_SEEN_ANNOUNCEMENT_START:
            const user = state.user
            user.unSeenAnnouncement = user.unSeenAnnouncement - 1
            return {
                ...state,
                user,
            }
        case userTypes.UPDATE_IS_NEW_ORDER_TO_FALSE_START:
            const user2 = state.user
            user2.is_new_order = false
            return {
                ...state,
                ...{ user: user2 },
            }
        case userTypes.UPDATE_IS_NEW_TICKET_TO_FALSE_START:
            const user3 = state.user
            user3.is_new_ticket = false
            return {
                ...state,
                ...{ user: user3 },
            }

        default:
            return state
    }
}

export default user
